<template>
    <div class="container-fluid shadow-lg" style="background-color: #F3F6F5; margin-top: -50px;">
        <div class="row flex-start-center" >
            <div class="col-12">
                <div class="max-w-4xl mx-auto px-4 sm:px-6 py-6 text-gray-800">
                    <h1 class="text-3xl font-bold mb-6">Privacy Policy</h1>


                    <p class="mb-4">
                    This Privacy Policy describes how we collect, use, and protect your information when you use our platform, which connects travelers with local guides in Mexico (and later globally).
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
                    <ul class="list-disc pl-6 mb-4">
                    <li>Personal details (name, email, phone number, payment info).</li>
                    <li>Travel preferences and booking details.</li>
                    <li>Location information (when you use the app).</li>
                    <li>Communication between travelers and guides through our platform.</li>
                    </ul>


                    <h2 class="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
                    <ul class="list-disc pl-6 mb-4">
                    <li>To process bookings and payments.</li>
                    <li>To connect travelers with local guides.</li>
                    <li>To improve our services and user experience.</li>
                    <li>To comply with legal obligations in Mexico and other regions.</li>
                    </ul>


                    <h2 class="text-xl font-semibold mt-6 mb-2">3. Sharing of Information</h2>
                    <p class="mb-4">
                    We do not sell your personal data. We may share limited information with:
                    </p>
                    <ul class="list-disc pl-6 mb-4">
                    <li>Local guides to fulfill bookings.</li>
                    <li>Payment providers to process transactions securely.</li>
                    <li>Authorities if required by law.</li>
                    </ul>


                    <h2 class="text-xl font-semibold mt-6 mb-2">4. Data Storage & Security</h2>
                    <p class="mb-4">
                    Your data is stored securely, and we use reasonable measures to protect it. However, no system is 100% secure.
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">5. International Transfers</h2>
                    <p class="mb-4">
                    As we expand globally, your data may be transferred and processed in other countries, with safeguards to protect your privacy.
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">6. Your Rights</h2>
                    <p class="mb-4">
                    Depending on your location, you may have rights to access, update, or delete your data, and to opt-out of certain uses.
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">7. Account &amp; Data Deletion</h2>
                    <p class="mb-4">
                    You can request deletion of your account and its associated data at any time, in either of the following ways:
                    </p>
                    <ul class="list-disc pl-6 mb-4">
                    <li><strong>In the app:</strong> go to <strong>Account &rarr; Account information</strong>, and under <strong>Delete Account</strong> tap <strong>Click here</strong>, then choose <strong>Permanently deactivate</strong> and confirm.</li>
                    <li><strong>By email:</strong> send a request from your registered email address to <a href="mailto:contact@farrther.com" style="color:#2563eb; text-decoration:underline;">contact@farrther.com</a>.</li>
                    </ul>
                    <p class="mb-4">
                    When your request is processed, personal data such as your name, email address, phone number, profile photo, bio, identity documents, and payout details is permanently removed. Certain records — such as transaction and payout history — may be retained where required for legal, tax, or accounting obligations.
                    </p>
                    <p class="mb-4">
                    For full step-by-step instructions, see our
                    <a href="https://farrther.com/delete-account.html" style="color:#2563eb; text-decoration:underline;">Account &amp; Data Deletion page</a>.
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">8. Children's Privacy</h2>
                    <p class="mb-4">
                    Our services are not intended for children under 18. We do not knowingly collect data from minors.
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">9. Changes to This Policy</h2>
                    <p class="mb-4">
                    We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised date.
                    </p>


                    <h2 class="text-xl font-semibold mt-6 mb-2">10. Contact Us</h2>
                    <p>
                    If you have any questions, please contact us at:
                    <br />
                    Email: contact@farrther.com
                    <br />
                    Phone: +1-865-254-2759
                    </p>
                    </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss" >
    .arrowpro:hover {
            animation: desplazar 1s linear infinite; /* Ajusta la cantidad de desplazamiento a la derecha */

        }
        @keyframes desplazar {
                0%, 100% {
                    transform: translateX(0); /* Estado inicial y final, sin desplazamiento */
                }
                50% {
                    transform: translateX(100%); /* Desplazamiento a la derecha en la mitad de la animación */
                }
        }
    .texthover:hover{
            border-bottom: 1px solid #133831;
            transform: scale(1.1);
            cursor: pointer;

        } 
</style>